<template>
  <div class="container">
    <div class="rightListOne">
          <div class="leftListOne_top">
            <span class="leftListOne_top_text">救援能力</span>
          </div>
          <div class="rightListOneCon">
              <div class="comtrantionRanking">
                  <div id="columnprefpEchart" style="width: 49%; height: 220px;float:left;margin-top:50px;">
                      </div>
                      <div class="symcxzb">
                          <el-row class="symcxzb_con">
                              <el-col :span="12" class="symcxzbcov">
                                  <el-row>
                                      <el-col :span="4">
                                          <img src="@/assets/images/cut/01img.png" alt="" class="taiyuanimg">
                                      </el-col>
                                      <el-col :span="20">
                                          <span class="symcxzbcity">生活物资</span>
                                          <span class="symcxzbnum">{{IndexDataList.rescueLiveGoods}}件</span>
                                      </el-col>
                                  </el-row>
                              </el-col>
                              <el-col :span="12" class="symcxzbcov">
                                  <el-row>
                                      <el-col :span="4">
                                          <img src="@/assets/images/cut/02.png" alt="" class="taiyuanimg">
                                      </el-col>
                                      <el-col :span="20">
                                          <span class="symcxzbcity">救援物资</span>
                                          <span class="symcxzbnum">{{IndexDataList.rescueHelpGoods}}件</span>
                                      </el-col>
                                  </el-row>
                              </el-col>
                              <el-col :span="12" class="symcxzbcov">
                                  <el-row>
                                      <el-col :span="4">
                                          <img src="@/assets/images/cut/03.png" alt="" class="taiyuanimg">
                                      </el-col>
                                      <el-col :span="20">
                                          <span class="symcxzbcity">专职救援人员</span>
                                          <span class="symcxzbnum">{{IndexDataList.rescueDutyMen}}人</span>
                                      </el-col>
                                  </el-row>
                              </el-col>
                              <el-col :span="12" class="symcxzbcov">
                                  <el-row>
                                      <el-col :span="4">
                                          <img src="@/assets/images/cut/04.png" alt="" class="taiyuanimg">
                                      </el-col>
                                      <el-col :span="20">
                                          <span class="symcxzbcity">社会志愿者</span>
                                          <span class="symcxzbnum">{{IndexDataList.rescueSocietyMen}}人</span>
                                      </el-col>
                                  </el-row>
                              </el-col>
                              <el-col :span="12" class="symcxzbcov">
                                  <el-row>
                                      <el-col :span="4">
                                          <img src="@/assets/images/cut/05.png" alt="" class="taiyuanimg">
                                      </el-col>
                                      <el-col :span="20">
                                           <span class="symcxzbcity">消防车</span>
                                          <span class="symcxzbnum">{{IndexDataList.rescueTruck}}辆</span>
                                      </el-col>
                                  </el-row>
                              </el-col>
                              <el-col :span="12" class="symcxzbcov">
                                  <el-row>
                                      <el-col :span="4">
                                          <img src="@/assets/images/cut/05.png" alt="" class="taiyuanimg">
                                      </el-col>
                                      <el-col :span="20">
                                           <span class="symcxzbcity">救援车辆</span>
                                          <span class="symcxzbnum">{{IndexDataList.rescueCar}}辆</span>
                                      </el-col>
                                  </el-row>
                              </el-col>
                          </el-row>
                      </div>
              </div>
          </div>
        </div>
        <div class="rightListOne">
          <div class="leftListOne_top">
            <span class="leftListOne_top_text">主体类型</span>
          </div>
          <div class="rightTwoList">
            <div class="cztxxtwoztlx" id="ztlxEch" ref="pieChart"></div>
          </div>
        </div>
        <div class="rightListOne">
          <div class="leftListOne_top">
            <span class="leftListOne_top_text">历史灾害</span>
          </div>
          <div class="rightListThree" style="overflow:hidden;margin-top:0.6vw;height:260px;">
            <div class="cztxxtwo" id="columnzxEchart"></div>
          </div>
        </div>
  </div>
</template>
 
<script>
import "echarts-gl";
import { queryIndexData, getBuildInfoChartData, getDisasterHistoryChartDataData} from '@/api';
export default {
  name: 'MyComponent',
  data () {
    return {
      IndexDataList:'',
      yearListdata:[],
      typeTotalListdata:[],
      valueListdata:[],
      nameListdata:[],
    }
  },
  created(){
    
  },
   mounted() {
    this.$nextTick(() => {
      this.queryIndexDataApi();
      this.getBuildInfoChartDataApi();
      this.getDisasterHistoryChartDataDataApi();
    });
  },
  methods:{
    queryIndexDataApi(){
      queryIndexData().then(res=>{
        this.IndexDataList = res.data
        this.drawLineprefp();
      })
    },
    getBuildInfoChartDataApi(){
      getBuildInfoChartData().then(res=>{
        this.nameListdata = res.data.nameList
        this.valueListdata = res.data.valueList
        this.fxqyEJiek();
        this.$emit('shili-List',res.data )
      })
    },
    getDisasterHistoryChartDataDataApi(){
      getDisasterHistoryChartDataData().then(res=>{
        this.yearListdata = res.data.yearList
        this.typeTotalListdata = res.data.typeTotalList
        this.drawLinezx();
      })
    },
    // 主题类型
    fxqyEJiek() {
      let myChart = this.$echarts.init(document.getElementById("ztlxEch"));
      let data = this.nameListdata
      data = data.map(item => ({name: item,textStyle:{color:"#fff"}}) )
      let seriesData = this.valueListdata
      seriesData = seriesData.map(item => ({value:item,selected:false,
        label:{
            show:false,
        }})
      )
      let mergedArray  = []
      seriesData.forEach((item,index) => {
          mergedArray.push({
            value:item.value,
            name:data[index].name,
            label:{
                show:false,
            },
            textStyle:{color:"#fff"}
          })
      });
      seriesData = seriesData.map(item => ({...item,selected:false,
        label:{
            show:false,
        }}))
      let option = {
        tooltip: {
          trigger: 'item',
          backgroundColor: "rgba(13, 64, 71, 0.50)",
          borderColor: "rgba(143, 225, 252, 0.60)",
          padding: 8,
          textStyle: {
            color: "#fff",
          },
          formatter: params => {
              return  params.data.name +" "+ params.data.value + '处'
          }
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          scrollDataIndex:5,
          animation : false,
          right: -90,
          top: 40,
          bottom: 20,
          data: data,
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['45%', '65%'],
            center: ['30%', '50%'],
            data: mergedArray,
            labelLine:{
                show:false
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      autoHover(myChart, option, seriesData.length, 3000);

      function autoHover(myChart, option, num, time) {
          var defaultData = {
              //设置默认值
              time: 2000,
              num: 50,
          };
          if (!time) {
              time = defaultData.time;
          }
          if (!num) {
              num = defaultData.num;
          }
          var count = 0;
          var timeTicket = null;
          timeTicket && clearInterval(timeTicket);
          timeTicket = setInterval(function () {
              myChart.dispatchAction({
                  type: 'downplay',
                  seriesIndex: 0, //serieIndex的索引值   可以触发多个
              });
              myChart.dispatchAction({
                  type: 'highlight',
                  seriesIndex: 0,
                  dataIndex: count,
              });
              option.legend.data[count].textStyle.color = '#50DCE6'
              option.legend.scrollDataIndex = count
              myChart.setOption(option, true);
              myChart.dispatchAction({
                  type: 'showTip',
                  seriesIndex: 0,
                  dataIndex: count,
              });
              option.legend.data[count].textStyle.color = '#ffffff';
              count++;
              if (count >= num) {
                  count = 0;
              }
          }, time);
          myChart.on('mouseover', function (params) {
              clearInterval(timeTicket);
              myChart.dispatchAction({
                  type: 'downplay',
                  seriesIndex: 0,
              });
              myChart.dispatchAction({
                  type: 'highlight',
                  seriesIndex: 0,
                  dataIndex: params.dataIndex,
              });
              // option.legend.data[params.dataIndex].textStyle.color = '#50DCE6'
              // option.legend.scrollDataIndex = params.dataIndex
              myChart.dispatchAction({
                  type: 'showTip',
                  seriesIndex: 0,
                  dataIndex: params.dataIndex,
              });
              option.legend.data = option.legend.data.map(item => ({...item, textStyle:{color: '#ffffff'}}))
              option.legend.data[params.dataIndex].textStyle.color = '#50DCE6'
              option.legend.scrollDataIndex = params.dataIndex
              myChart.setOption(option, true);
          });
          myChart.on('mouseout', function (params) {
              timeTicket && clearInterval(timeTicket);
              option.legend.data[params.dataIndex].textStyle.color = '#ffffff'
              timeTicket = setInterval(function () {
                myChart.dispatchAction({
                  type: 'downplay',
                  seriesIndex: 0, //serieIndex的索引值   可以触发多个
              });
              myChart.dispatchAction({
                  type: 'highlight',
                  seriesIndex: 0,
                  dataIndex: count,
              });
              if (option.legend.data[count]) {
                option.legend.data[count].textStyle.color = '#50DCE6'
                option.legend.scrollDataIndex = count
                myChart.setOption(option, true);
                myChart.dispatchAction({
                    type: 'showTip',
                    seriesIndex: 0,
                    dataIndex: count,
                });
                option.legend.data[count].textStyle.color = '#ffffff';
                count++;
                if (count >= defaultData.num) {
                    count = 0;
                }
              }
              
              }, defaultData.time);
          });
      }
    },
    drawLinezx() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(
        document.getElementById("columnzxEchart")
      );
      // 绘制图表
      let legendData = [this.typeTotalListdata[0].name, this.typeTotalListdata[1].name, this.typeTotalListdata[2].name, this.typeTotalListdata[3].name, this.typeTotalListdata[4].name, this.typeTotalListdata[5].name];
      let xAxisData = this.yearListdata;
      let seriesData = this.typeTotalListdata[0].valueList;
      let seriesData1 = this.typeTotalListdata[1].valueList;
      let seriesData2 = this.typeTotalListdata[2].valueList;
      let seriesData3 = this.typeTotalListdata[3].valueList;
      let seriesData4 = this.typeTotalListdata[4].valueList;
      let seriesData5 = this.typeTotalListdata[5].valueList;
      let option;
      option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(13, 64, 71, 0.50)",
          borderColor: "rgba(143, 225, 252, 0.60)",
          padding: 8,
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "3%",
          right: "1%",
          top: "15%",
          bottom: "5%",
          containLabel: true,
        },
        // legend: {
        //   icon: "rect",
        //   right: "0%",
        //   top: "2%",
        //   itemWidth: 3, // 设置宽度
        //   itemHeight: 3, // 设置高度
        //   itemGap: 5, // 设置间距
        //   textStyle: {
        //     //图例文字的样式
        //     color: "#fff",
        //     fontSize: 10,
        //   },
        // },
        xAxis: {
          boundaryGap: true,
          data: xAxisData,
          axisLine: {
            lineStyle: {
              color: "rgba(117, 168, 202, 0.4)",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#fff",
          },
        },
        yAxis: [
          {
            name: "单位：次",
            type: "value",
            inverse: false,
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(117, 168, 202, 0.3)",
                type: "dashed",
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#0A5C95",
              },
            },
            axisLabel: {
              formatter: "{value}",
              textStyle: {
                color: "#fff",
                fontSize: 12,
              },
            },
            nameTextStyle: {
              color: "#89BFE5",
              padding: [0, 0, 0, 15],
              fontSize: 12,
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: legendData[0],
            type: "line",
            symbol: "circle", //设定为实心点
            showAllSymbol: true,
            symbolSize: 0,
            smooth: true,
            itemStyle: {
              normal: {
                color: `#00CBFE`,
                lineStyle: {
                  //线的颜色
                  color: `#00CBFE`,
                  width: 1.5,
                },
                areaStyle: {
                  //新版渐变色实现
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(1, 180, 255, 0.2)",
                      },
                      {
                        offset: 1,
                        color: "rgba(1, 180, 255, 0.1)",
                      },
                    ],
                  },
                },
              },
            },
            data: seriesData,
          },
          {
            name: legendData[1],
            type: "line",
            symbol: "circle", //设定为实心点
            showAllSymbol: true,
            symbolSize: 0,
            smooth: true,
            itemStyle: {
              normal: {
                color: `#FFDF04`,
                lineStyle: {
                  //线的颜色
                  color: `#FFDF04`,
                  width: 1.5,
                },
                areaStyle: {
                  //新版渐变色实现
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(255, 223, 4, 0.2)",
                      },
                      {
                        offset: 1,
                        color: "rgba(255, 223, 4, 0.1)",
                      },
                    ],
                  },
                },
              },
            },
            data: seriesData1,
          },
          {
            name: legendData[2],
            type: "line",
            symbol: "circle", //设定为实心点
            showAllSymbol: true,
            symbolSize: 0,
            smooth: true,
            itemStyle: {
              normal: {
                color: `#8B4BFF`,
                lineStyle: {
                  //线的颜色
                  color: `#8B4BFF`,
                  width: 1.5,
                },
                areaStyle: {
                  //新版渐变色实现
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(139, 75, 255, 0.2)",
                      },
                      {
                        offset: 1,
                        color: "rgba(139, 75, 255, 0.1)",
                      },
                    ],
                  },
                },
              },
            },
            data: seriesData2,
          },
          {
            name: legendData[3],
            type: "line",
            symbol: "circle", //设定为实心点
            showAllSymbol: true,
            symbolSize: 0,
            smooth: true,
            itemStyle: {
              normal: {
                color: `#2291E3`,
                lineStyle: {
                  //线的颜色
                  color: `#2291E3`,
                  width: 1.5,
                },
                areaStyle: {
                  //新版渐变色实现
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(34, 145, 227, 0.2)",
                      },
                      {
                        offset: 1,
                        color: "rgba(34, 145, 227, 0.1)",
                      },
                    ],
                  },
                },
              },
            },
            data: seriesData3,
          },
          {
            name: legendData[4],
            type: "line",
            symbol: "circle", //设定为实心点
            showAllSymbol: true,
            symbolSize: 0,
            smooth: true,
            itemStyle: {
              normal: {
                color: `#86CF70`,
                lineStyle: {
                  //线的颜色
                  color: `#86CF70`,
                  width: 1.5,
                },
                areaStyle: {
                  //新版渐变色实现
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(134, 207, 112, 0.2)",
                      },
                      {
                        offset: 1,
                        color: "rgba(134, 207, 112, 0.1)",
                      },
                    ],
                  },
                },
              },
            },
            data: seriesData4,
          },
          {
            name: legendData[5],
            type: "line",
            symbol: "circle", //设定为实心点
            showAllSymbol: true,
            symbolSize: 0,
            smooth: true,
            itemStyle: {
              normal: {
                color: `#ff0000`,
                lineStyle: {
                  //线的颜色
                  color: `#ff0000`,
                  width: 1.5,
                },
                areaStyle: {
                  //新版渐变色实现
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(255, 61, 81, 0.2)",
                      },
                      {
                        offset: 1,
                        color: "rgba(255, 61, 81, 0.1)",
                      },
                    ],
                  },
                },
              },
            },
            data: seriesData5,
          },
        ],
      };

      window.addEventListener("resize", function () {
        myChart.resize();
      });
      // 动态显示tootip
      var faultByHourIndex = 0; //播放所在下标
      setInterval(function () {
        //使得tootip每隔三秒自动显示
        myChart.dispatchAction({
          type: "showTip", // 根据 tooltip 的配置项显示提示框。
          seriesIndex: 0,
          dataIndex: faultByHourIndex,
        });
        faultByHourIndex++;
        if (faultByHourIndex >= option.series[0].data.length) {
          faultByHourIndex = 0;
        }
      }, 1500);
      option && myChart.setOption(option);
    },
    drawLineprefp() {
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById("columnprefpEchart"));
            let data = [];
            let barChartList = [
                {
                    name: '生活物资',
                    value: this.IndexDataList.rescueLiveGoods
                },
                {
                    name: '救援物资',
                    value: this.IndexDataList.rescueHelpGoods
                },
                {
                    name: '专职救援人员',
                    value: this.IndexDataList.rescueDutyMen
                },
                {
                    name: '社会志愿者',
                    value: this.IndexDataList.rescueSocietyMen
                },
                {
                    name: '消防车',
                    value: this.IndexDataList.rescueTruck
                },
                {
                    name: '救援车辆',
                    value: this.IndexDataList.rescueCar
                }];
            var color = ['#84FFDD', '#3ED7FF', ' #24FFF8', '#E5D659', '#82c8ef', '#ffeec9', '#aefffe', '#bfc5ff', '#d7a8ff', '#93ffd0'];
            for (var i = 0; i < barChartList.length; i++) {
                data.push(
                    {
                        value: barChartList[i].value,
                        name: barChartList[i].name,
                        itemStyle: {
                            normal: {
                                borderWidth: 1,
                                shadowBlur: 4,
                                borderRadius: 0, // 圆角
                                borderColor: color[i],
                                shadowColor: color[i],
                                color: color[i],
                            }
                        }
                    },
                    {
                        value: 4,
                        name: '',
                        itemStyle: {
                            normal: {
                                label: {
                                    show: false
                                },
                                labelLine: {
                                    show: false
                                },
                                color: 'rgba(0, 0, 0, 0)',
                                borderColor: 'rgba(0, 0, 0, 0)',
                                borderWidth: 0
                            }
                        }
                    }
                );
            }
            var seriesOption = [
                {
                    name: 'pie2',
                    type: 'pie',
                    radius: [58, 60],
                    color: '#068898',
                    label: {
                        show: false
                    },
                    labelLine: {
                        show: false
                    },
                    data: [1],
                    silent: true
                },
                {
                    name: 'pie1',
                    type: 'pie',
                    radius: [70, 80],
                    grid: {
                        containLabel: true
                    },
                    label: {
                        show: false,
                        position: 'center',
                        formatter: '{c_style|{c}}\n{b_style|{b}}',
                        rich: {
                            b_style: {
                                fontSize: 16,
                                fontWeight: 400,
                                color: '#fff'
                            },
                            c_style: {
                                padding: [0, 0, 10, 0],
                                fontSize: 28,
                                fontWeight: 'bold',
                                color: '#fff'
                            }
                        }
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '14',
                            fontWeight: 'normal'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: data
                }
            ];
            let option = {
                color: color,
                tooltip: {
                    show: false
                },
                series: seriesOption
            }
            // 绘制图表
            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
            handleChartLoop(option, myChart);//定义名称
            // 饼图自动轮播
            function handleChartLoop(option, myChart) {
                if (!myChart) {
                    return
                }
                let currentIndex = 0 // 当前高亮图形在饼图数据中的下标
                let changePieInterval = setInterval(selectPie, 1000) // 设置自动切换高亮图形的定时器

                // 取消所有高亮并高亮当前图形
                function highlightPie() {
                    // 遍历饼图数据，取消所有图形的高亮效果
                    for (var idx in option.series[1].data) {
                        myChart.dispatchAction({
                            type: 'downplay',
                            seriesIndex: 1,
                            dataIndex: idx
                        })
                    }
                    // 高亮当前图形
                    myChart.dispatchAction({
                        type: 'highlight',
                        seriesIndex: 1,
                        dataIndex: currentIndex
                    })
                }

                // 用户鼠标悬浮到某一图形时，停止自动切换并高亮鼠标悬浮的图形
                myChart.on('mouseover', (params) => {
                    clearInterval(changePieInterval)
                    currentIndex = params.dataIndex
                    highlightPie()
                })

                // 用户鼠标移出时，重新开始自动切换
                myChart.on('mouseout', (params) => {
                    if (changePieInterval) {
                        clearInterval(changePieInterval)
                    }
                    changePieInterval = setInterval(selectPie, 1000)
                })

                // 高亮效果切换到下一个图形
                function selectPie() {
                    var dataLen = option.series[1].data.length
                    currentIndex = (currentIndex + 2) % dataLen
                    highlightPie()
                }
            }
        },
  }
}
</script>

<style  scoped>
@import "@/assets/css/index.css";
@import "@/assets/css/left.css";
.comtrantionRanking {
    width: 425px;
    height: 100%;
    margin-left: 10px;
}
.symcxzb {
    width: 49%;
    height: 265px;
    float: left;
    padding-left: 1%;
}
 .symcxzb_tit {
  font-size: 16px;
  color: #B0E2F7;
  margin-top: 10px;
  display: block;
}
.symcxzb_tit span {
    font-size: 50px;
    color: #06CEF8;
    line-height: 1px;
}

.symcxzb_con {
    height: 265px;
    margin-top: 5px;
    overflow: auto;
}

/* 定义滚动条样式 */
.symcxzb_con::-webkit-scrollbar {
    width: 2px;
    height: 2px;
    background-color: rgba(240, 240, 240, 0.1);
}

/*定义滚动条轨道 内阴影+圆角*/
.symcxzb_con::-webkit-scrollbar-track {
    box-shadow: inset 0 0 0px rgba(240, 240, 240, .5);
    border-radius: 10px;
    background-color: rgba(240, 240, 240, .5);
}

/*定义滑块 内阴影+圆角*/
.symcxzb_con::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 0px rgba(113, 255, 209, .8);
    background-color: rgba(113, 255, 209, .8);
}

.symcxzbcov {
    margin-top: 40px;
}
.symcxzbcity {
    font-size: 14px;
    color: #fff;
    display: block;
}

.symcxzbnum {
    font-size: 14px;
    color: #fff;
    display: block;
}
</style>